<div class="container-tab-lists">
  <!-- Loading Indicator -->
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading assessment information...</p>
    </div>
  }

  <!-- No Wave Message -->
  @if (!isLoading && currentWaveId <= 0) {
    <div class="no-wave-message">
      <mat-icon>info</mat-icon>
      <p>No wave is currently assigned to the selected branch ({{defaults.managementid}}).</p>
      <p>Please contact your administrator to assign a wave to this branch.</p>
    </div>
  }

  <!-- Protocol Tabs -->
  @if (!isLoading && currentWaveId > 0) {
    <div>
      <!-- No Protocols Message -->
      @if (protocols.length === 0) {
        <div class="no-protocols-message">
          <mat-icon>warning</mat-icon>
          <p>No protocols are assigned to this wave.</p>
          <p>Please contact your administrator to configure protocols for this wave.</p>
        </div>
      }
      <!-- Dynamic Protocol Tabs -->
      @if (protocols.length > 0) {
        <mat-tab-group orientation="vertical" #tabGroup
          [mat-stretch-tabs]="false"
          (selectedTabChange)="onProtocolTabChange($event.index)">
          @for (protocol of protocols; track protocol) {
            <mat-tab [label]="protocol.name">
              <div class="inner-tcontainer-tab new-table-style">
                <!-- Loading Factors Indicator -->
                @if (isLoadingFactors) {
                  <div class="loading-container">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p>Loading factors...</p>
                  </div>
                }
                <div class="header-button-section">
                  <div>
                    @if (!isExcelModeEnabled && !isEditModeEnabled && protocols.length > 0 && defaults.userHasSafetySystemExcellenceRole()) {
                      <a class='kpi-button-menu' title="Excel"
                        (click)="onClickExcel()">
                        Excel
                      </a>
                    }
                    @if (isExcelModeEnabled) {
                      <a class='kpi-button-menu' title="Download Excel"
                        (click)="onClickDownloadAssessments()">
                        <span class='glyphicon glyphicon-download-alt'></span> Download Excel
                      </a>
                    }
                    @if (isExcelModeEnabled) {
                      <a class='kpi-button-menu' title="Upload Excel"
                        (click)="onClickUploadAssessments()">
                        <span class='glyphicon glyphicon-upload'></span> Upload Excel
                      </a>
                    }
                    @if (isExcelModeEnabled) {
                      <a class='kpi-button-menu' title="Exit Excel Mode"
                        (click)="onClickExitExcel()">
                        Exit Excel Mode
                      </a>
                    }
                    @if (isEditModeEnabled) {
                      <a class='kpi-save-menu save-button' title="Save"
                        (click)="saveAssessments()">
                        <span class='glyphicon glyphicon-floppy-disk'></span> Save
                      </a>
                    }
                    @if (protocols.length > 0 && defaults.userHasSafetySystemExcellenceRole()) {
                      <a class='kpi-button-menu' title="Edit values"
                        (click)="toggleEditMode()">
                        <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
                      </a>
                    }
                  </div>
                  <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
                    Edit Mode is enabled. Please click on Save button to save all changes
                  </h5>
                </div>
                <!-- Factors Table -->
                @if (!isLoadingFactors && protocolFactors.length > 0) {
                  <div>
                    <table mat-table [dataSource]="protocolFactors" multiTemplateDataRows matSort
                      class="mat-elevation-z8 mat-table-custom" id="oshfactor">
                      <!-- Factor Code Column -->
                      <ng-container matColumnDef="factorCode">
                        <th mat-header-cell *matHeaderCellDef>Factor</th>
                        <td mat-cell *matCellDef="let factor">
                          <p [innerHTML]="factor.factorCode"></p>
                        </td>
                      </ng-container>
                      <!-- Description Column -->
                      <ng-container matColumnDef="factorDescription">
                        <th mat-header-cell *matHeaderCellDef class="column-description">Description</th>
                        <td mat-cell *matCellDef="let factor" class="column-description">
                          <p [innerHTML]="factor.factorDescription || '-'"></p>
                        </td>
                      </ng-container>
                      <!-- Observations Column -->
                      <ng-container matColumnDef="observations">
                        <th mat-header-cell *matHeaderCellDef>Observations</th>
                        <td mat-cell *matCellDef="let factor" [matTooltip]="factor.observations || ''"
                          matTooltipClass="text-tooltip">
                                    <textareaoverlay [inputControls]="{
                                        isOpenOverlay: isOpenTextAreaOverlay,
                                        textAreaId: 'Observations_ta_' + factor.factorId,
                                        isEditable: isEditModeEnabled,
                                        maxCommentLength: 4000,
                                        comment: factor.observations
                                        }" [customSpanClass]="{'boldText': !isEditModeEnabled}"
                            (commentChange)="onTextFieldChange($event.comment, $event.textAreaId, factor)">
                          </textareaoverlay>
                        </td>
                      </ng-container>
                      <!-- Recommendations Column -->
                      <ng-container matColumnDef="recommendations">
                        <th mat-header-cell *matHeaderCellDef>Focus Areas</th>
                        <td mat-cell *matCellDef="let factor" [matTooltip]="factor.recommendations || ''"
                          matTooltipClass="text-tooltip">
                                    <textareaoverlay [inputControls]="{
                                        isOpenOverlay: isOpenTextAreaOverlay,
                                        textAreaId: 'Recommendations_ta_' + factor.factorId,
                                        isEditable: isEditModeEnabled,
                                        maxCommentLength: 4000,
                                        comment: factor.recommendations
                                        }" [customSpanClass]="{'boldText': !isEditModeEnabled}"
                            (commentChange)="onTextFieldChange($event.comment, $event.textAreaId, factor)">
                          </textareaoverlay>
                        </td>
                      </ng-container>
                      <!-- Stage Column -->
                      <ng-container matColumnDef="stage">
                        <th mat-header-cell *matHeaderCellDef class="column-stage">Stage</th>
                        <td mat-cell *matCellDef="let factor" class="column-stage"
                          [matTooltip]="getStageDescription(factor)" matTooltipClass="stage-tooltip">
                          <p [innerHTML]="getStageLabel(factor.factorStageAssessment)"
                          [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                          <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }" [items]="stages"
                            class="integratedNgSelect" bindLabel="label" bindValue="id" [clearable]="false"
                            [searchable]="false" [(ngModel)]="factor.factorStageAssessment"
                            [clearOnBackspace]="false" (ngModelChange)="onStageChange(factor)"
                            appendTo="body">
                          </ng-select>
                        </td>
                      </ng-container>
                      <!-- Priority Column -->
                      <ng-container matColumnDef="priority">
                        <th mat-header-cell *matHeaderCellDef class="column-priority">Priority</th>
                        <td mat-cell *matCellDef="let factor" class="column-priority">
                          @if (isEditModeEnabled) {
                            <mat-checkbox
                              [(ngModel)]="factor.isPriority"
                              (ngModelChange)="onPriorityChange(factor)">
                            </mat-checkbox>
                          }
                          @if (!isEditModeEnabled && factor.isPriority) {
                            <span class="priority-star" matTooltip="Priority item">&#9733;</span>
                          }
                          @if (!isEditModeEnabled && !factor.isPriority) {
                            <span>-</span>
                          }
                        </td>
                      </ng-container>
                      <!-- History Column -->
                      <ng-container matColumnDef="history">
                        <th mat-header-cell *matHeaderCellDef>History</th>
                        <td mat-cell *matCellDef="let factor">
                          @if (factor.assessmentId) {
                            <button mat-icon-button
                              matTooltip="View Assessment History"
                              style="width:100%"
                              (click)="viewAssessmentHistory(factor)">
                              <mat-icon>history</mat-icon>
                            </button>
                          }
                        </td>
                      </ng-container>
                      <!-- Attachments Column -->
                      <ng-container matColumnDef="attachments">
                        <th mat-header-cell *matHeaderCellDef>Attachments</th>
                        <td mat-cell *matCellDef="let factor">
                          <button mat-icon-button
                            matTooltip="Attachments"
                            style="width:100%"
                            (click)="onOpenAssessmentAttachments(factor)">
                            <mat-icon>attachment</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                      <tr mat-header-row class="tableheader" *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let factor; columns: displayedColumns;" class="item"
                        [class.alternative2]="isEditModeEnabled === true">
                      </tr>
                    </table>
                  </div>
                }
                <!-- No Factors Message -->
                @if (!isLoadingFactors && protocolFactors.length === 0) {
                  <div class="no-data-message">
                    <mat-icon>info</mat-icon>
                    <p>No factors found for this protocol.</p>
                  </div>
                }
              </div>
            </mat-tab>
          }
          <!-- Action Items Tab -->
          <mat-tab label="Action Items">
            <div class="inner-tcontainer-tab new-table-style">
              <!-- Action Bar -->
              @if (defaults.userHasSafetySystemExcellenceRole()) {
                <div class="action-buttons">
                  <div class="OrangeButton">
                    <button mat-raised-button
                      (click)="onAddActionItem()"
                      class="button-color-fix">
                      <mat-icon class="icon-color-fix">add</mat-icon>
                      Add Action Item
                    </button>
                  </div>
                </div>
              }
              <!-- Priority findings without a linked action must be addressed first -->
              @if (unlinkedPriorityFactors.length > 0) {
                <div class="priority-warning-banner">
                  <mat-icon>warning</mat-icon>
                  <div class="priority-warning-content">
                    <strong>Priority items require a follow-up action.</strong>
                    <span>The following priority items have no linked action yet — add at least one action for each:</span>
                    <ul>
                      @for (f of unlinkedPriorityFactors; track f) {
                        <li>{{ f.factorCode }} - {{ f.factorDescription }}</li>
                      }
                    </ul>
                  </div>
                </div>
              }
              <!-- Data Table -->
              <app-data-table
                [columns]="tableColumns"
                [data]="tableData"
                [loading]="isLoading"
                [alternateRowColors]="true"
                [highlightOnHover]="true"
                [emptyMessage]="'No action items found for the selected branch.'"
                [loadingMessage]="'Loading action items...'">
                <!-- Custom cell template for Actions column -->
                <ng-template #cellTemplate let-row let-column="column" let-value="value">
                  @if (column.key === 'progress') {
                    @if (hasProgress(row)) {
                      <div class="progress-cell"
                        [class.progress-complete]="getProgressValue(row) >= 100"
                        >
                        <svg class="progress-ring" viewBox="0 0 36 36" width="26" height="26" aria-hidden="true">
                          <circle class="progress-ring-track" cx="18" cy="18" r="15.5"></circle>
                          <circle class="progress-ring-arc" cx="18" cy="18" r="15.5"
                            pathLength="100"
                            [attr.stroke-dasharray]="getProgressValue(row) + ' 100'"
                          transform="rotate(-90 18 18)"></circle>
                        </svg>
                        <span class="progress-cell-value">{{ getProgressValue(row) }}</span>
                      </div>
                    } @else {
                      <span class="progress-empty">—</span>
                    }
                  }
                  @if (column.key === 'actions') {
                    <div class="action-buttons-cell">
                      <!-- Show lock icon if item is closed and user is not an SSX admin -->
                      @if (!row.status && !defaults.isSafetySystemExcellenceAdmin()) {
                        <button mat-icon-button
                          class="action-icon-button"
                          matTooltip="Closed - Cannot Edit"
                          disabled>
                          <mat-icon class="block-button">lock</mat-icon>
                        </button>
                      }
                      <!-- Show edit icon if item is active, or if item is closed and user is an SSX admin -->
                      @if ((row.status && defaults.userHasSafetySystemExcellenceRole()) || (!row.status && defaults.isSafetySystemExcellenceAdmin())) {
                        <button mat-icon-button
                          class="action-icon-button edit-button"
                          (click)="onEditActionItem(value); $event.stopPropagation()"
                          matTooltip="Edit">
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                      @if (row.status && !disableReminder(row) && defaults.userHasSafetySystemExcellenceRole()) {
                        <button mat-icon-button
                          class="action-icon-button"
                          (click)="onConfigureAlert(value, 'reminder'); $event.stopPropagation()"
                          matTooltip="Configure Reminder">
                          <mat-icon [ngClass]="hasReminder(row) ? 'active-button' : ''">alarm</mat-icon>
                        </button>
                      }
                      @if (row.status && defaults.userHasSafetySystemExcellenceRole()) {
                        <button mat-icon-button
                          class="action-icon-button"
                          (click)="onConfigureAlert(value, 'alert'); $event.stopPropagation()"
                          matTooltip="Configure Alert">
                          <mat-icon [ngClass]="hasAlert(row) ? 'active-button' : ''">notifications</mat-icon>
                        </button>
                      }
                      @if (row.status && defaults.userHasSafetySystemExcellenceRole()) {
                        <button mat-icon-button
                          class="action-icon-button delete-button"
                          (click)="onDeleteActionItem(value); $event.stopPropagation()"
                          matTooltip="Delete">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                      <button mat-icon-button
                        class="action-icon-button"
                        (click)="onOpenActionItemAttachments(value); $event.stopPropagation()"
                        matTooltip="Attachments">
                        <mat-icon>attachment</mat-icon>
                      </button>
                    </div>
                  }
                  <!-- Default rendering for other columns -->
                  @if (column.key !== 'actions' && column.key !== 'progress') {
                    <span>{{ getCellValue(row, column) }}</span>
                  }
                </ng-template>
              </app-data-table>
            </div>
          </mat-tab>
        </mat-tab-group>
      }
    </div>
  }
</div>